import { SeccionMenuDto } from '@nucleo/navegacion/opcion-menu-dto';
import { Idioma } from '@nucleo/i18n/idioma.enum';
import { DiccionarioIdiomas } from '@nucleo/i18n/traduccion-util';
import { RUTAS_APP } from './app-rutas.const';

const TEXTOS_MENU_FRONT_ES = {
  miCuenta: 'Mi cuenta',
  miPerfil: 'Mi perfil',
};

type TextosMenuFront = typeof TEXTOS_MENU_FRONT_ES;

const TEXTOS_MENU_FRONT: DiccionarioIdiomas<TextosMenuFront> = {
  es: TEXTOS_MENU_FRONT_ES,
  en: {
    miCuenta: 'My account',
    miPerfil: 'My profile',
  },
};

/**
 * Opciones del menú lateral PROPIAS DEL FRONT (pantallas sin API en el backend) en el idioma indicado. Se muestran
 * después de las secciones que llegan de `GET /account/menu` (ver `NavegacionServicio`). Las opciones con
 * `rolesPermitidos` deben coincidir con el `rolGuard` de su ruta. Toda pantalla que consume APIs se agrega desde
 * Seguridad → Menú (backend), no aquí.
 */
export function menuNavegacionFront(idioma: Idioma): SeccionMenuDto[] {
  const t = TEXTOS_MENU_FRONT[idioma];
  return [
    {
      identificador: 'cuenta',
      titulo: t.miCuenta,
      opciones: [
        {
          identificador: 'mi-perfil',
          etiqueta: t.miPerfil,
          icono: 'pi pi-user',
          ruta: RUTAS_APP.FUNCIONALIDADES.absolutas.miPerfil(),
        },
      ],
    },
  ];
}
